var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.appI18nKey}),(_vm.messageStatus)?_c('BaseNotification',{attrs:{"pendingCountData":_vm.pendingCountData},on:{"closePrepayment":_vm.closePrepayment}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }